import React from 'react';
import Reflux from 'reflux';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from 'Components';
import {Button, Col, Row, Input, InputNumber, Modal, Select} from "antd";
import {openNotice, config} from 'Utils';
import {
    getEscrowCustlist,
    getEscrowSalesUnitlist,
    getRequestShipHistory,
    list,
    requestShip,
    stockScreening
} from '../../service/shipRequest';
import moment from "moment/moment";

class ShipRequestQuery extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            rows: [],
            stockType: [],
            escrowCustlist: [],
            escrowSalesUnitlist: [],
            total: 0,
            loading: false,
            btnLoading: false,
            visible: false,
            receiptCustId: '',
            selectedRowKeysOutside: [],
            searchObj: {
                itemNum: '',
                itemDesc: '',
                orderNumber: '',
                organizationId: '',
                custPoNumber: '',
                closeHomologous: '',
                salesUnitId: '',
                unOnhand: false,
                qhFlag: '',
                bookedDateFrom: moment().add(-1, 'y').format('YYYY-MM-DD'),
                bookedDateTo: moment().format('YYYY-MM-DD'),
                p: 1,
                s: 10
            },
            searchHisObj: {
                p: 1,
                s: 10,
                orderNumber: '',
                lineNumber: '',
                itemNum: ''
            },
            hisRow: [],
            hisTotal: 0,
            hisLoading: false,
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}') || ''
        };
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.historyOk = this.historyOk.bind(this);
        this.historyCancel = this.historyCancel.bind(this);

    };

    routeLeaveHook(nextLocation) {
    };

    componentDidMount() {
        stockScreening().then(res => {
            let arr = [];
            res.data.forEach(x => {
                arr.push({
                    text: x.delvName,
                    value: x.id
                })
            });
            this.setState({stockType: arr})
        });
        getEscrowCustlist().then(res => {
            let arr = [];
            res.data.forEach(x => {
                arr.push({
                    text: x.name + "_" + x.address + "_" + x.seller + "_" + x.phone,
                    value: x.id
                })
            });
            this.setState({escrowCustlist: arr})
        })
        getEscrowSalesUnitlist().then(res => {
            let arr = [];
            res.data.forEach(x => {
                arr.push({
                    text: x.name,
                    value: x.id
                })
            });
            this.setState({escrowSalesUnitlist: arr})
        })
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    };

    goView(url) {
        hashHistory.push(url);
    };

    getData() {
        const self = this;
        self.setState({loading: true});
        const {searchObj} = this.state;
        list(searchObj).then(res => {
            if (res.status) {
                self.setState({total: res.total, rows: res.data, loading: false});
            } else {
                console.error(res.message);
                this.setState({loading: false})
            }
        });
    };

    getHistory(record) {
        const self = this;
        self.setState({hisLoading: true});
        var searchHisObj = this.state.searchHisObj;
        searchHisObj.orderNumber = record.orderNumber;
        searchHisObj.lineNumber = record.lineNumber;
        searchHisObj.itemNum = record.itemNum;
        getRequestShipHistory(searchHisObj).then(res => {
            if (res.status) {
                self.setState({hisTotal: res.total, hisRows: res.data, hisLoading: false});
            } else {
                openNotice('error', '获取历史数据失败！');
            }
        })
    }


    pageChange(page, pageSize) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.getData();
        });
    }

    hisPageChange(page, pageSize) {
        const self = this;
        this.setState({
            searchHisObj: {...this.state.searchHisObj, s: pageSize, p: page},
            hisLoading: true
        }, function () {
            self.getHistory(self.state.record);
        });
    }

    advanceReset() {
        const self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                itemNum: '',
                itemDesc: '',
                orderNumber: '',
                custPoNumber: '',
                organizationId: '',
                closeHomologous: '',
                salesUnitId: '',
                unOnhand: false,
                qhFlag: '',
                bookedDateFrom: moment().add(-1, 'y').format('YYYY-MM-DD'),
                bookedDateTo: moment().format('YYYY-MM-DD'),
                p: 1,
                s: 10
            }
        }, () => {
            self.getData();
        })
    };

    advanceSubmit(form) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, p: 1}, loading: true}, function () {
            self.getData();
        });
    };


    openHistory = (record, index, value) => {
        this.setState({visible: true, record: record});
        this.getHistory(record);
    }

    setFilterParam(name, value) {
        if (name === 'orderTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    bookedDateFrom: value.from,
                    bookedDateTo: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };


    onOutsideSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({selectedRowKeysOutside: selectedRowKeys});
    };

    exportList() {
        let param = this.state.searchObj;
        let url = `${config.server}/api/v1/dms/shipRequest/listExp`;
        let urlStr = '';
        Object.keys(param).forEach(item => {
            urlStr += `&${item}=${param[item]}`;
        });
        url += `?${urlStr.substring(1)}`;
        window.open(url);
    }

    shipRow = () => {
        const self = this;
        if (self.state.selectedRowKeysOutside == '') {
            openNotice('warning', '请勾选行再次提交');
            return;
        }
        if (self.state.receiptCustId == '') {
            openNotice('warning', '请选择收货人');
            return;
        }
        var isValid = true;
        self.setState({btnLoading: true});
        var selectedRowKeys = self.state.selectedRowKeysOutside;
        var rows = self.state.rows.filter(x => selectedRowKeys.includes(x.deliveryDetailId));
        rows.forEach(item => {
            if (item.requestQuantity == null || item.requestQuantity == 0) {
                isValid = false;
                return;
            }
            item.quantityAll = item.availableQuantity;
        })
        if (!isValid) {
            openNotice('warning', '请输入发运数量');
            self.setState({btnLoading: false});
            return;
        }
        var escrowCustlist = self.state.escrowCustlist;
        var receiptCust = '';
        escrowCustlist.forEach(item => {
            if (item.value == self.state.receiptCustId) {
                receiptCust = item.text;
            }
        })

        rows.forEach(item => {
            item.quantity = item.requestQuantity;
            item.receiptCustId = self.state.receiptCustId;
            item.receiptCust = receiptCust;
        })

        var param = {"tgShipRequestLinesList": rows};
        requestShip(param).then(res => {
            if (res.status) {
                openNotice('success', '请求成功');
                this.setState({btnLoading: false, selectedRowKeysOutside: []}, () => {
                    this.getData();
                })
            } else {
                openNotice('error', res.message);
                rows.forEach(item => {
                    item.quantity = null;
                })
                this.setState({btnLoading: false})
            }
        });
    }

    onChangeQty(record, index, value) {
        var self = this;
        var rows = this.state.rows;
        rows[index].requestQuantity = value;

        var selectedRowKeys = self.state.selectedRowKeysOutside;
        if (!selectedRowKeys.includes(record.deliveryDetailId) && record.quantity == null) {
            selectedRowKeys.push(record.deliveryDetailId)
        }

        self.setState({rows: rows, selectedRowKeysOutside: selectedRowKeys});
    }

    historyOk = () => {
        this.setState({visible: false});
    }

    historyCancel = () => {
        this.setState({visible: false});
    }

    escrowCustSelect = (value) => {
        this.setState({receiptCustId: value});
    }

    render() {
        const {
            rows,
            total,
            loading,
            selectedRowKeysOutside,
            searchObj,
            btnLoading,
            visible,
            hisLoading,
            hisTotal,
            searchHisObj,
            hisRows,
            stockType,
            escrowCustlist,
            escrowSalesUnitlist
        } = this.state;

        const requestQuantitySum = rows
            .filter(row => selectedRowKeysOutside.includes(row.deliveryDetailId))
            .reduce((sum, row) => sum + (Number(row.requestQuantity) || 0), 0);


        const advanceProps = {
            fileds: [
                {
                    name: 'itemNum',
                    label: '物料编码',
                    text: '输入物料编码',
                    defaultValue: searchObj.itemNum,
                    type: 'default'
                },
                {
                    name: 'itemDesc',
                    label: '物料名称',
                    text: '输入物料名称',
                    defaultValue: searchObj.itemDesc,
                    type: 'default'
                }, {
                    name: 'orderNumber',
                    label: '订单编号',
                    text: '输入订单编号',
                    defaultValue: searchObj.orderNumber,
                    type: 'default'
                },
                {
                    name: 'custPoNumber',
                    label: '要货单号',
                    text: '输入要货单号',
                    defaultValue: searchObj.custPoNumber,
                    type: 'default'
                }, {
                    name: 'closeHomologous',
                    label: '结算对应号',
                    text: '输入结算对应号',
                    defaultValue: searchObj.closeHomologous,
                    type: 'default'
                }, {
                    name: 'orderTime',
                    label: '登记日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startBookDate || '',
                        end: searchObj.endBookDate || ''
                    },
                }, {
                    name: 'organizationId',
                    label: '提货组织',
                    text: '选择提货组织',
                    defaultValue: searchObj.organizationId,
                    type: 'select',
                    multiple: false,//支持多选
                    options: stockType

                }, {
                    name: 'unOnhand',
                    label: '排除零库存',
                    text: '排除零库存',
                    defaultValue: searchObj.unOnhand,
                    type: 'SwitchInput',
                    labelStyle: {width: "300px"}
                },
                {
                    name: 'salesUnitId',
                    label: '托管单位',
                    text: '选择托管单位',
                    defaultValue: searchObj.salesUnitId,
                    type: 'select',
                    multiple: false,//支持多选
                    options: escrowSalesUnitlist

                },
                {
                    name: 'qhFlag',
                    label: '是否欠货',
                    text: '是否欠货',
                    defaultValue: searchObj.qhFlag,
                    type: 'select',
                    multiple: false,//支持多选
                    options: [{text: '是', value: true}, {text: '否', value: false}]
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };


        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'deliveryDetailId',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '托管单位',
                    dataIndex: 'salesUnitName'
                }, {
                    title: '结算对应号',
                    dataIndex: 'closeHomologous'
                }, {
                    title: '要货单号',
                    dataIndex: 'custPoNumber'
                }, {
                    title: '订单编号',
                    dataIndex: 'orderNumber'
                }, {
                    title: '登记日期',
                    dataIndex: 'bookedDate',
                    render: text => <span>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>
                }, {
                    title: '提货组织',
                    dataIndex: 'organizationName'
                }, {
                    title: '行号',
                    dataIndex: 'lineNumber'
                }, {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                }, {
                    title: '物料描述',
                    dataIndex: 'itemDesc'
                }, {
                    title: '库存属性',
                    dataIndex: 'stockType'
                }, {
                    title: '子库存',
                    dataIndex: 'subinventory'
                }, {
                    title: '订单数量',
                    dataIndex: 'orderedQuantity'
                }, {
                    title: '欠货数量',
                    dataIndex: 'qhQuantity'
                }, {
                    title: '未发数量',
                    dataIndex: 'quantityUnShip'
                }, {
                    title: '请求中数量',
                    dataIndex: 'quantity'
                }, {
                    title: '可用量',
                    dataIndex: 'availableQuantity'
                }, {
                    title: '本次发运数量',
                    dataIndex: 'requestQuantity',
                    width: 120,
                    render: (text, record, index) => <div><InputNumber
                        value={text}
                        max={record.quantityUnShip > record.availableQuantity ? record.availableQuantity : record.quantityUnShip}
                        min={0}
                        onChange={this.onChangeQty.bind(this, record, index)}/></div>
                }, {
                    title: '操作',
                    dataIndex: 'save',
                    width: 150,
                    render: (text, record, index) => {
                        return (<Button style={{background: '#red'}} size={'small'} type="primary"
                                        onClick={this.openHistory.bind(this, record, index)}>请求历史</Button>);
                    },
                },
            ],
            rows,
            rowSelection: {
                selectedRowKeys: selectedRowKeysOutside,
                onChange: this.onOutsideSelectChange,
                getCheckboxProps: record => ({
                    disabled: record.quantity > 0
                })
            },
        };

        const historyProps = {
            rowKey: 'id',
            loading: hisLoading,
            pageParam: {
                total: hisTotal,
                current: searchHisObj.p,//当前页码
                pageSize: searchHisObj.s,//当前分页数
                onChange: this.hisPageChange,
            },
            columns: [
                {
                    title: '订单编号',
                    dataIndex: 'orderNumber'
                }, {
                    title: '结算对应号',
                    dataIndex: 'closeHomologous'
                }, {
                    title: '行号',
                    dataIndex: 'lineNumber'
                }, {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                },
                {
                    title: '物料描述',
                    dataIndex: 'itemDesc',
                },
                {
                    title: '未发数量',
                    dataIndex: 'quantityUnShip'
                },
                {
                    title: '请求数量',
                    dataIndex: 'quantity'
                },
                {
                    title: '请求时间',
                    dataIndex: 'createdDate',
                    render: text => <span>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>
                },
                {
                    title: '出库单号',
                    dataIndex: 'deliveryId'
                },
                {
                    title: '处理时间',
                    dataIndex: 'transactionDate',
                    render: text => <span>{text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
                },
            ],
            rows: hisRows,
        };


        return <div className="dms-body">
            <DmsTab options={[`托管订单发货`]} defaultKey={0}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div style={{marginBottom: 28, position: 'relative', minHeight: 32}}>
                    <Button type="primary" style={{marginRight: 8}}
                            onClick={this.shipRow.bind(this)} loading={btnLoading}>请求发运</Button>
                    <Select style={{width: '500px'}} dropdownMatchSelectWidth={true} placeholder={"请选择送货地址"}
                            onSelect={this.escrowCustSelect}>
                        {escrowCustlist.map(function (item, key) {
                            return <Select.Option key={key + ''} value={item.value + ''}>{item.text}</Select.Option>;
                        })}
                    </Select>
                    <div style={{position: 'absolute', right: 13, display: 'flex', alignItems: 'center'}}>
                        <span style={{marginRight: 16}}>本次发运数量汇总：{requestQuantitySum}</span>
                        <Button icon="export" onClick={this.exportList.bind(this)}>导出</Button>
                    </div>
                </div>
                <TableView {...tableViewProps}/>
            </div>

            <Modal
                visible={visible}
                title='发运历史信息'
                onOk={this.historyOk}
                onCancel={this.historyCancel}
                maskClosable={false}
                width={1200}
                style={{top: 20}}
            >
                <TableView {...historyProps} bordered style={{marginTop: 10}}/>
            </Modal>

        </div>
    }
}

export default withRouter(ShipRequestQuery);


// WEBPACK FOOTER //
// ./src/routes/shipRequest/shipRequestQuery.js